/*----- Core -----*/
import React, { useEffect}	from "react"
import queryString 					from 'query-string'
import ReactPixel  					from 'react-facebook-pixel'

/*----- Components -----*/
import Header  from './components/Header'
import Footer  from './components/Footer'

/*----- Styles -----*/
import Styles	from "./Styles"

/*----- Assets -----*/
// import Illustration 			from '../../assets/landing_page/illustration_a.svg'
import AndrasReggiAvatar  from '../../assets/landing_page/andres_reggi_avatar.jpg'
import InsuranceItem1  		from '../../assets/landing_page/icons/insurance_item-01.svg'
import InsuranceItem2 		from '../../assets/landing_page/icons/insurance_item-02.svg'
import InsuranceItem3  		from '../../assets/landing_page/icons/insurance_item-03.svg'
import InsuranceItem4  		from '../../assets/landing_page/icons/insurance_item-04.svg'
import InsuranceItem5  		from '../../assets/landing_page/icons/insurance_item-05.svg'
import InsuranceItem6  		from '../../assets/landing_page/icons/insurance_item-06.svg'
import InsuranceItem7  		from '../../assets/landing_page/icons/insurance_item-07.svg'
import InsuranceItem8  		from '../../assets/landing_page/icons/insurance_item-08.svg'
import Shape  				  	from '../../assets/landing_page/shape.svg'

/*----- Ant Design -----*/
import { Row, Col } from 'antd'

/*----- Components -----*/
import SectionContainer   	from '../../components/commons/SectionContainer'
import HandlerButton		  	from '../../components/button/HandlerButton'
import ProducerContactForm  from './components/ContactForm'
import Paragraph 						from '../../components/text/Paragraph'
import HeroParagraph 			  from '../../components/hero/HeroParagraph'

const LandingPageProducer = ({ location }) => {

	useEffect(() => {
		return ReactPixel.init('637184876961692')
	})
	
	const { photoId } = queryString.parse(location.search)

	const handleClick = () => {
		const el = document.getElementById("producer-form")
		el.scrollIntoView({
			behavior: 'smooth'
		})
	}

	const RenderImage = () => {
		const image = require(`../../assets/landing_page/illustration_${ photoId ? photoId : 1 }.jpg`)
		return <img src={ image } alt="" />
	}

	return (
		<Styles>

				<Header />

				<SectionContainer>
					<Row>
						<Col xs={24} sm={{ span: 24 }} md={{ span:24 }} lg={{ span: 14 }} xl={{ span: 10 }}>
							<div className="portrait__text-container">
								<h1 className="portrait__title">Asegurá tu hogar</h1>
								<h2 className="portrait__subtitle">Cuidá tu esfuerzo.</h2>
								<HandlerButton content="COTIZÁ" onClick={handleClick}/>
							</div>
						</Col>
						<Col xs={24} sm={{ span: 24 }} md={{ span:24 }} lg={{ span: 10 }} xl={{ span: 14 }}>
							<div className="portrait__image-container">
								{ RenderImage() }
							</div>
						</Col>
					</Row>
				</SectionContainer>

				<SectionContainer>
					<Row className="avatar-and-form">
						<Col xs={24} sm={{ span: 24 }} md={{ span:10 }} lg={{ span: 10 }} xl={{ span: 10 }}>
							<div className="producer-avatar">
								<div className="producer-avatar__img">
									<div>
										<img src={AndrasReggiAvatar} alt="profile"/>
									</div>
									<div className="producer-avatar__mat">
										Andrés Reggi <br/>
										Mat. 73.767
									</div>
								</div>
								<Paragraph content="¡Hola! Mi nombre es Andrés y soy productor asesor de seguros. Ingresá tus datos y te contactaré a la brevedad para brindarte la opción que más se ajuste a tus necesidades."/>	
							</div>
						</Col>
						<Col xs={24} sm={{ span: 24 }} md={{ span:13, offset: 1 }} lg={{ span: 13, offset: 1 }} xl={{ span: 13,  offset: 1 }}>
							<div className="contact-form-container" id="producer-form">
								<ProducerContactForm />
							</div>
						</Col>
					</Row>
				</SectionContainer>

				<div style={{position: 'relative'}}>
					<img src={Shape} alt="" style={{position: 'absolute'}} />
				</div>

				<div className="insurance-details__background">
					<SectionContainer>
						<Row className="insurance-details">
							<HeroParagraph title="¿Qué cubrimos?" />
							<ul className="insurance-details__list">
								<li className="insurance-details__item">
									<img src={InsuranceItem1} alt="" />
									<p>Incendio (edificio y contenido)</p>
								</li>
								<li className="insurance-details__item">
									<img src={InsuranceItem2} alt="" />
									<p>Todo Riesgo para electrodomésticos</p>
								</li>
								<li className="insurance-details__item">
									<img src={InsuranceItem3} alt="" />
									<p>Daños por granizo</p>
								</li>
								<li className="insurance-details__item">
									<img src={InsuranceItem4} alt="" />
									<p>Bienes específicos dentro y fuera del hogar (ej: laptops)</p>
								</li>
								<li className="insurance-details__item">
									<img src={InsuranceItem5} alt="" />
									<p>Daños a electrodomésticos por variación de tensión</p>
								</li>
								<li className="insurance-details__item">
									<img src={InsuranceItem6} alt="" />
									<p>Cristales</p>
								</li>
								<li className="insurance-details__item">
									<img src={InsuranceItem7} alt="" />
									<p>Robo y/o Hurto</p>
								</li>
								<li className="insurance-details__item">
									<img src={InsuranceItem8} alt="" />
									<p>Contactanos y conocé todos los riesgos que tu combinado puede cubrir.</p>
								</li>
							</ul>
						</Row>
						<Row>
							<HandlerButton content="OBTENÉ TU COTIZACIÓN" onClick={handleClick}/>
						</Row>
					</SectionContainer>
				</div>

				<SectionContainer>
					<Row>
						<HeroParagraph title="¿Cuáles son los principales beneficios que te ofrecemos?" />
					</Row>
					<Row>
						<ul className="benefit__list">
							<li className="benefit__item">
								<Paragraph bold content="Servicio las 24 hs"/>
								<Paragraph content="Un Productor Asesor de Seguros estará a tu disposición de manera personalizada cuando lo necesites para evacuar todas tus dudas y consultas."/>
							</li>
							<li className="benefit__item">
								<Paragraph bold content="Gama de coberturas"/>
								<Paragraph content="Podés elegir entre una amplia variedad de coberturas para el hogar y sumas aseguradas, priorizando tus necesidades y presupuesto."/>
							</li>
							<li className="benefit__item">
								<Paragraph bold content="Beneficios adicionales"/>
								<Paragraph content="Asistencia las 24hs para emergencias de plomería, cerrajería, electricidad,etc."/>
							</li>
							<li className="benefit__item">
								<Paragraph bold content="Sin franquicia"/>
								<Paragraph content="La compañía se hace cargo del 100% de los gastos ante un siniestro."/>
							</li>
							<li className="benefit__item">
								<Paragraph bold content="Propietarios e inquilinos"/>
								<Paragraph content="Nos adaptamos a tus necesidades."/>
							</li>
						</ul>
					</Row>
					<Row>
						<HandlerButton content="OBTENÉ TU COTIZACIÓN" onClick={handleClick}/>
					</Row>
				</SectionContainer>

				<Footer />

		</Styles>
	)
}

export default LandingPageProducer;